import { COLORS } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const ConversationInstructionBody = dynamic(() => import('../../new-portal/conversational-ai/Instruction'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const ConversationInstructionTobNav = () => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { push, pop } = useConversationAIFlow()
  const appRouter = useAppRouter({ stackPush: push })
  const { t } = useTranslation()

  return (
    <div className="flex w-screen flex-row items-center justify-start py-[12px] px-[20px]">
      <div className="">
        <QIcon_chevron_left width={'24px'} height={'24px'} color={COLORS.BLACK} onClick={() => appRouter.back()} />
      </div>
    </div>
  )
}

const ConversationInstructionActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const courseId = router.query?.courseId

  return (
    <WebviewStackContainer height="52px" title={<ConversationInstructionTobNav />} border={false}>
      <ConversationInstructionBody courseId={courseId} />
    </WebviewStackContainer>
  )
}

export default ConversationInstructionActivity
